module.exports = __webpack_public_path__ + "static/img/K.72235cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/simba/K.png
// module id = Mm4l
// module chunks = 0